import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { VideoService } from 'src/app/services/video.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-draggable-component',
    templateUrl: './draggable-component.component.html',
    styleUrls: [`./draggable-component.component.css`],
    standalone: true,
    imports: [TranslateModule, CommonModule, FormsModule]
})
export class DraggableComponentComponent {
  isButtonDisabled: boolean = false; // Button is enabled by default

  isPauseButtonDisabled: boolean = true;
  @ViewChild('draggableDiv') draggableElement!: ElementRef;
  modalRef!: MatDialogRef<any>;
  @ViewChild('start_session') StartRecordTemplate: TemplateRef<any>
  @ViewChild('stop_session') StopRecordTemplate: TemplateRef<any>
  iconClass: string = 'fa fa-play-circle';
  StopRecordbutton:Boolean=true


  position = { x: 100, y: 100 }; // Initial position
  private isDragging = false;
  private currentX = 0;
  private currentY = 0;
  private initialX = 0;
  private initialY = 0;
  isPaused = false; // State to track pause or resume

  constructor(
    private videoService: VideoService,
    private dialog: MatDialog,
  ) {
    // Bind the methods to the class instance
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
  }

  ngOnInit() {
    window.onbeforeunload = null;
    // Add global event listeners
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
  }

  ngOnDestroy() {
    // Remove global event listeners
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  }

  StartRecord() {
    this.modalRef = this.dialog.open(this.StartRecordTemplate);
  }

  cancelRequest() {
    this.modalRef.close()
  }

  Ok() {
    this.modalRef.close()
  }

  StartRecordConfirm() {
    this.videoService.updateBoolean(true);
    this.modalRef.close();
    this.iconClass = 'fa fa-circle text-danger'; // Change to circle icon and red color
    const button = document.getElementById('Start');
    if (button) {
      button.classList.add('blink'); // Add the blink class
      this.isButtonDisabled = true;

      this.StopRecordbutton = false;
      this.isPauseButtonDisabled = false;


    }
  }

  // Toggle between pause and resume
  toggleRecord() {
    if (this.isPaused) {
      this.ReusumeRecord();
    } else {
      this.PauseRecord();
    }
    this.isPaused = !this.isPaused; // Toggle the state
  }
  PauseRecord() {
    this.videoService.PauseRecording(true)
  }

  // Resume the recording
  ReusumeRecord() {
    this.videoService.ResumeRecording(true)
  }

  StopRecord() {
    this.modalRef = this.dialog.open(this.StopRecordTemplate);
    setTimeout(() => {
      this.modalRef.close();
    }, 2000)
    this.videoService.updateBoolean(false);
    const button = document.getElementById('Start');
    if (button) {
      button.classList.remove('blink'); // Remove the blink class after 2 seconds
      this.iconClass = 'fa fa-play-circle'
      this.StopRecordbutton = true;
      this.isButtonDisabled = false;
      this.isPauseButtonDisabled = true;
      this.isPaused = false;


    }
  }

  startDragging(event: MouseEvent) {
    this.isDragging = true;
    this.initialX = event.clientX - this.position.x;
    this.initialY = event.clientY - this.position.y;
  }

  private handleMouseMove(event: MouseEvent) {
    if (this.isDragging) {
      event.preventDefault();

      this.currentX = event.clientX - this.initialX;
      this.currentY = event.clientY - this.initialY;

      // Update position
      this.position.x = this.currentX;
      this.position.y = this.currentY;
    }
  }

  private handleMouseUp() {
    this.isDragging = false;
  }
}
